export default __webpack_public_path__ + "static/media/wicket.c8885184.svg";